'use client';

import { c as _c } from "react/compiler-runtime";
import { BrightcovePlayer, type BrightcovePlayerProps } from './BrightcovePlayer';
import { VideoPopupCTA } from './VideoPopupCTA';
interface VideoPlayerProps extends BrightcovePlayerProps {
  playAsPopup?: boolean;
  videoPlayerAspectRatio?: string;
}
export const VideoPlayer = props => {
  const $ = _c(7);
  const {
    videoId,
    accountId,
    playerId,
    playAsPopup: t0,
    videoPlayerAspectRatio
  } = props;
  const playAsPopup = t0 === undefined ? false : t0;
  let t1;
  if ($[0] !== accountId || $[1] !== playAsPopup || $[2] !== playerId || $[3] !== props || $[4] !== videoId || $[5] !== videoPlayerAspectRatio) {
    t1 = playAsPopup ? <VideoPopupCTA videoId={videoId} autoplay={true}><div className="pointer-events-none"><BrightcovePlayer videoId={videoId} accountId={accountId} playerId={playerId} autoplay={false} videoPlayerAspectRatio={videoPlayerAspectRatio} /></div></VideoPopupCTA> : <BrightcovePlayer {...props} />;
    $[0] = accountId;
    $[1] = playAsPopup;
    $[2] = playerId;
    $[3] = props;
    $[4] = videoId;
    $[5] = videoPlayerAspectRatio;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};